export interface SeriesPoint {
  x: number;
  y: number;
}

export interface SvgPaths {
  line: string;
  area: string;
}

export function pathFromSeries(
  points: SeriesPoint[],
  width: number,
  height: number
): SvgPaths {
  if (points.length === 0) return { line: "", area: "" };

  const maxY = points.reduce((m, p) => (p.y > m ? p.y : m), 0);
  const denom = maxY === 0 ? 1 : maxY;

  const xStep = points.length === 1 ? 0 : width / (points.length - 1);

  const coords = points.map((p, i) => {
    const px = i * xStep;
    const py = height - (p.y / denom) * height;
    return `${px},${py}`;
  });

  const line = `M${coords.join(" L")}`;
  const firstX = 0;
  const lastX = (points.length - 1) * xStep;
  const area = `${line} L${lastX},${height} L${firstX},${height} Z`;

  return { line, area };
}
